import * as Yup from "yup";
import { dateToyyyyMMdd } from "../../../util/date";
import { getPatchOperations } from "../../../util/form";
import { validateTilDatoEfterEllerSammeSomFraDato } from "../../../util/validation";

export const personTyperForm = (config: {
  /**
   * required to assign persontype to person
   */
  personId: string;
  /**
   * required when editing an existing persontype
   */
  personPersonTypeId?: string;
}): FormConfig<PersonTyperDTO> => {
  const { personId, personPersonTypeId } = config;
  return {
    title: "persontype",
    validationSchema: Yup.object({
      persontypeNr: Yup.number().required("Rolle/kvalifikation skal være sat"),
      periodeFraDato: Yup.date()
        .nullable()
        .required("Startdato skal være sat")
        .test(
          "periodeFraDato",
          "Startdato kan ikke være efter slutdato",
          function (periodeFraDato) {
            if (!this.parent.periodeTilDatoInklusiv || !periodeFraDato) {
              return true;
            }
            return validateTilDatoEfterEllerSammeSomFraDato(
              periodeFraDato,
              this.parent.periodeTilDatoInklusiv,
            );
          },
        ),
      periodeTilDatoInklusiv: Yup.date()
        .nullable()
        .test(
          "periodeTilDatoInklusiv",
          "Slutdato kan ikke være før startdato",
          function (periodeTilDatoInklusiv) {
            if (!this.parent.periodeFraDato || !periodeTilDatoInklusiv) {
              return true;
            }
            return validateTilDatoEfterEllerSammeSomFraDato(
              this.parent.periodeFraDato,
              periodeTilDatoInklusiv,
            );
          },
        ),
    }),
    form: [
      {
        component: "kode-select",
        kodeListeType: "Persontype",
        id: "persontypeNr",
        label: "Rolle/kvalifikation",
        placeholder: "Vælg persontype",
        initialValue: "",
        isRequired: true,
      },
      {
        component: "datepicker",
        id: "periodeFraDato",
        label: "Startdato",
        initialValue: "",
        isRequired: true,
      },
      {
        component: "datepicker",
        id: "periodeTilDatoInklusiv",
        label: "Slutdato",
        initialValue: "",
      },
    ],
    lockedValues: [
      {
        id: "personPersonTypeId",
        value: personPersonTypeId,
      },
      {
        id: "personId",
        value: personId,
      },
    ],
    get: `person/${personId}/typer/${personPersonTypeId}`,
    post(values: PersonTyperDTO) {
      const { periodeFraDato, periodeTilDatoInklusiv, persontypeNr } = values;
      return {
        query: `person/${personId}/typer/`,
        body: {
          periodeFraDato: dateToyyyyMMdd(periodeFraDato),
          periodeTilDatoInklusiv: periodeTilDatoInklusiv
            ? dateToyyyyMMdd(periodeTilDatoInklusiv)
            : "9999-12-31",
          persontypeNr,
        },
      };
    },
    patch(values: Partial<PersonTyperDTO>) {
      const ops = getPatchOperations(values);
      return {
        query: `person/${personId}/typer/${personPersonTypeId}`,
        body: JSON.stringify(ops),
      };
    },
    delete() {
      return {
        query: `person/${personId}/typer/${personPersonTypeId}`,
      };
    },
  };
};
